//TODO: Get these values from an api call
const featureFlags = {
    signatureValidation: false,
}

export const isFeatureEnabled = (feature) => {
    return featureFlags[feature] === true;
}


// WEBPACK FOOTER //
// ./src/utils/featureFlagHelper.js